module.exports = __webpack_public_path__ + "static/media/bg-4.f96ed948.jpg";